// extracted by mini-css-extract-plugin
export default {"main_container":"styles_main_container__rV7oF","buttons_container":"styles_buttons_container__dvWYW","button":"styles_button__aRAw-","unit":"styles_unit__y58Jx"};